import type { AspectRatio } from "@/lib/model/Frame";
import { mapAspectRatioToMaxWidthAndHeight } from "@/lib/utils/cameraUtils";
import { forwardRef } from "react";
import Webcam from "react-webcam";

interface WebcamDisplayProps {
  isFlashing: boolean;
  countDownTime: number;
  isCapturing: boolean;
  aspectRatio: AspectRatio;
}

export const WebcamDisplay = forwardRef<Webcam, WebcamDisplayProps>(
  ({ isFlashing, countDownTime, aspectRatio, isCapturing }, ref) => {
    const maxWidthAndHeight = mapAspectRatioToMaxWidthAndHeight(aspectRatio);
    return (
      <div className="mt-8 border-vintage-blue border-3 rounded-xl relative overflow-hidden">
        <Webcam
          mirrored={true}
          width={1500}
          height={1500}
          videoConstraints={{
            width: 1500,
            height: 1500,
          }}
          forceScreenshotSourceSize={true}
          screenshotFormat="image/jpeg"
          screenshotQuality={1}
          className={`rounded-lg object-cover ${maxWidthAndHeight}`}
          ref={ref}
        />
        {/* Flash overlay */}
        {isFlashing && (
          <div className="absolute inset-0 bg-white rounded-lg animate-flash pointer-events-none" />
        )}
        {countDownTime > 0 && isCapturing && (
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full flex items-center justify-center">
            <p className="text-vintage-red font-bold text-[40px]">
              {countDownTime}
            </p>
          </div>
        )}
      </div>
    );
  }
);
